import { captureException } from '../tracking/sentry/sentry';

export function formatDate({
  date,
  locale,
  options,
}: {
  date: Date;
  locale?: string;
  options?: Intl.DateTimeFormatOptions;
}) {
  try {
    return new Intl.DateTimeFormat(locale, options).format(date);
  } catch (e) {
    captureException(e);
    return new Date(date).toLocaleDateString();
  }
}

/**
 * There are cases when we want to showcase the UTC date independently
 * of where in the world the user is. In this case, we want to make sure
 * that whatever year, month, or day the UTC date is in, that exact same
 * date is shown for the user.
 */
export function getLocalDateWithoutTimezone(date: Date): Date {
  const dateInISO = date.toISOString();
  const dateIndependentOfTimezone = dateInISO.substring(0, dateInISO.length - 1);
  const localDateAsIfItWasTheUTCDate = new Date(dateIndependentOfTimezone);
  return localDateAsIfItWasTheUTCDate;
}
